<path
    d="M5 12H19"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
<path
    d="M12 5L19 12L12 19"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
/>
